var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewsletter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M19.5 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v13.5a2.5 2.5 0 0 0 2.5 2.5v0Zm0 0h.5v0a3 3 0 0 0 3-3v0a3 3 0 0 0-3-3h-.5M7 14.088h6M7 17h4.5M17 4a2 2 0 0 1 2 2v11m0 0v1.09c0 .503.407.91.91.91H20a1 1 0 0 0 0-2h-1ZM8.644 8.333 6.5 8l1.473 3.37 4.527-.906V6.723l-1.62 1.11L9.353 6.38l-.708 1.953Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewsletter);
export default __webpack_public_path__ + "static/media/newsletter.058c641b115b493599e9b17982f9151c.svg";
export { ForwardRef as ReactComponent };